import { render } from "./Accordion.vue?vue&type=template&id=783f9e4d"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"

import exportComponent from "/Users/greg/sites/queens/wp-content/themes/queens/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/twig/components/accordion/Accordion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "783f9e4d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('783f9e4d', __exports__)) {
    api.reload('783f9e4d', __exports__)
  }
  
  module.hot.accept("./Accordion.vue?vue&type=template&id=783f9e4d", () => {
    api.rerender('783f9e4d', render)
  })

}


export default __exports__